// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 493 ? "bf5f3635" : chunkId) + "." + {"148":"764d2fc88b039e74","289":"7e23cee97649139f","493":"730038c2b861858f","874":"231cfb2b7b61c4be"}[chunkId] + ".js";
};